import { NullableString } from 'packages/lib/common-types/types';

export const localeDate = (date: NullableString): NullableString =>
  date === null
    ? null
    : new Date(date.endsWith('Z') ? date : `${date}Z`).toLocaleString();

export const localeTs = (date: null | number): null | string =>
  date === null ? null : new Date(date / 1000).toLocaleString();

export function formatDateTime(date: Date): string {
  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'short',
    timeStyle: 'medium',
  }).format(date);
}

export function minutesBetweenDates(dt2: Date, dt1: Date): number {
  let diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60;
  return Math.abs(Math.round(diff));
}
